module.exports = __webpack_public_path__ + "img/3420151.8ff585f9.png";